import { Link } from "react-router-dom";
import { ShieldCheck, Lock, Eye, AlertTriangle } from "lucide-react";

export default function Privacy() {
  return (
    <div className="min-h-screen bg-aurora text-white px-6 md:px-12 py-10 max-w-3xl mx-auto" data-testid="privacy-page">
      <Link to="/" className="font-display text-xl font-black"><span className="text-gradient-pink">S</span><span className="text-neoncyan">0</span><span className="text-gradient-pink">rted</span></Link>
      <h1 className="font-display text-4xl md:text-5xl font-black tracking-tighter mt-8">Privacy & Safety</h1>

      <div className="space-y-5 mt-7">
        <Section icon={ShieldCheck} title="Privacy-first by default">
          We never sell your data. Your progress is yours. Public leaderboards and any organisation links are <strong>opt-in</strong> only. You can hide yourself with one click.
        </Section>
        <Section icon={Lock} title="Strong account security">
          Encrypted passwords (bcrypt), HTTPS-only cookies, session-based auth and Google OAuth. We don't share account info with partners.
        </Section>
        <Section icon={Eye} title="What we don't do">
          We don't give legal, financial or medical advice. The AI mentor is for general guidance only — for personal decisions, please see a professional.
        </Section>
        <Section icon={AlertTriangle} title="If you're in crisis">
          <ul className="list-disc list-inside text-white/80 space-y-1 mt-1">
            <li><strong>Lifeline</strong>: 13 11 14 (24/7)</li>
            <li><strong>Beyond Blue</strong>: 1300 22 4636 (24/7)</li>
            <li><strong>Kids Helpline</strong> (5–25): 1800 55 1800</li>
            <li><strong>Emergency</strong>: dial 000</li>
          </ul>
        </Section>
      </div>

      <div className="mt-10 flex gap-3">
        <Link to="/" className="btn-secondary-neon" data-testid="privacy-back">Back home</Link>
      </div>
    </div>
  );
}

function Section({ icon: Icon, title, children }) {
  return (
    <div className="glass-card p-6">
      <div className="flex items-start gap-3">
        <Icon className="text-neoncyan flex-shrink-0 mt-1" size={22}/>
        <div>
          <h3 className="font-display text-xl font-extrabold">{title}</h3>
          <div className="text-white/75 mt-1.5 leading-relaxed">{children}</div>
        </div>
      </div>
    </div>
  );
}
